
import { ShippingMethod } from "../../Enums/ShippingMethod";
import { formatPriceBRL } from "../../Utils/DataFormatters";
import { FaFileSignature } from "react-icons/fa";

type OrderSummaryProps = {
  getTotalCartItems?: () => number | null;
  originalTotalPrice?: number | null;
  orderProductDiscount?: number | null;
  orderCouponDiscount?: number | null;
  orderShippingPrice?: number | null;
  orderShippingMethod?: ShippingMethod | null;
  orderFinalPrice?: number | null;
  orderInterest?: number | null;
  orderBankingBilletFee?: number | null;
  orderBaseBankingBilletFee?: number | null;
  orderCreditCardSurcharge?: number | null;
};

const OrderSummary = ({ 
  getTotalCartItems, 
  originalTotalPrice,
  orderProductDiscount,
  orderCouponDiscount,
  orderShippingPrice,
  orderShippingMethod,
  orderFinalPrice,
  orderInterest,
  orderBankingBilletFee,
  orderBaseBankingBilletFee,
  orderCreditCardSurcharge
}: OrderSummaryProps) => {

  const hasBankingBilletFee = orderBankingBilletFee != null && orderBankingBilletFee > 0;
  const baseFee = orderBaseBankingBilletFee ?? orderBankingBilletFee ?? 0;
  const isInstallmentsFee = hasBankingBilletFee && orderBankingBilletFee! > baseFee;
  const boletosLabel = isInstallmentsFee ? "Taxa boletos" : "Taxa boleto";
  const shouldShowShipping =
    orderShippingPrice != null && orderShippingMethod !== ShippingMethod.StorePickup;
  const isFreeShipping =
    orderShippingPrice === 0 && orderShippingMethod === ShippingMethod.FreeShipping;

  return (
    <div className={`flex flex-col bg-white border p-4 gap-3 rounded shadow`}>
      <div className="flex items-center gap-2 mb-5">
        <FaFileSignature className="text-primary-600" />
        <h4 className="text-md font-semibold">{"RESUMO"}</h4>
      </div>
      <div className="flex justify-between items-center px-1">
        <p className="text-xs">{"Total produto(s)"}:</p>
        <p className="text-sm">{formatPriceBRL(originalTotalPrice ?? getTotalCartItems?.() ?? 0)}</p>
      </div>

      {orderProductDiscount != null && orderProductDiscount > 0 && (
        <div className="flex justify-between items-center px-1">
          <p className="text-xs">{"Desconto produtos"}:</p>
          <p className="text-sm">- {formatPriceBRL(orderProductDiscount)}</p>
        </div>
      )}

      {orderCouponDiscount != null && orderCouponDiscount > 0 && (
        <div className="flex justify-between items-center px-1">
          <p className="text-xs">{"Desconto cupom"}:</p>
          <p className="text-sm">- {formatPriceBRL(orderCouponDiscount)}</p>
        </div>
      )}

      {shouldShowShipping && (
        <div className="flex justify-between items-center px-1">
          <p className="text-xs">{"Frete"}:</p>
          <p className="text-sm">
            {isFreeShipping ? "Grátis" : `+ ${formatPriceBRL(orderShippingPrice ?? 0)}`}
          </p>
        </div>
      )}

      {orderCreditCardSurcharge != null && orderCreditCardSurcharge > 0 && (
        <div className="flex justify-between items-center px-1">
          <p className="text-xs">{"Taxa cartão de crédito"}:</p>
          <p className="text-sm">+ {formatPriceBRL(orderCreditCardSurcharge)}</p>
        </div>
      )}

      {orderInterest != null && orderInterest > 0 && (
        <div className="flex justify-between items-center px-1">
          <p className="text-xs">{"Juros"}:</p>
          <p className="text-sm">+ {formatPriceBRL(orderInterest)}</p>
        </div>
      )}

      {hasBankingBilletFee && (
        <div className="flex justify-between items-center px-1">
          <p className="text-xs">{boletosLabel}:</p>
          <p className="text-sm">+ {formatPriceBRL(orderBankingBilletFee)}</p>
        </div>
      )}

      {orderFinalPrice != null && (
        <div className="flex justify-between items-center bg-primary-120 rounded px-1 py-1">
          <p className="text-xs font-bold">{"Total do pedido"}:</p>
          <p className="text-sm font-bold">{formatPriceBRL(orderFinalPrice)}</p>
        </div>
      )}
    </div>
  );
};

export default OrderSummary;
